import React from 'react'
import styles from './ClientTwoColumns.scss'
import cs from 'classnames'

const ClientTwoColumns = ({ col1, col2, isPhone }) => (
	<div className={styles.columnsWrapper}>
		<div className={cs(styles.column, isPhone && styles.mobileColumn)}>
			{col1.map((item, i) => (
				<div key={i} className={styles.keyValuePair}>
					<div className={styles.keyCont}>
						<div className={styles.key}>{item.label}</div>
					</div>
					<div className={styles.valCont}>
						<div className={styles.value}>{item.value}</div>
					</div>
				</div>
			))}
		</div>
		<div className={cs(styles.column, isPhone && styles.mobileColumn)}>
			{col2.map((item, i) => (
				<div key={i} className={styles.keyValuePair}>
					<div className={styles.keyCont}>
						<div className={styles.key}>{item.label}</div>
					</div>
					<div className={styles.valCont}>
						<div className={styles.value}>{item.value}</div>
					</div>
				</div>
			))}
		</div>
	</div>
)
export default ClientTwoColumns



// WEBPACK FOOTER //
// ./elements/ClientTwoColumns.jsx